import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";
var DEFAULT_OFFSET = 8;
export var getNodeSize = function getNodeSize(el) {
  var _el$style$transform$s, _el$style$transform$s2, _el$style$transform$s3;
  if (!el || (typeof window === "undefined" ? "undefined" : _typeof(window)) !== 'object') {
    return {
      width: 0,
      height: 0
    };
  }
  var _ref = el.getBoundingClientRect() || {},
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 0 : _ref$width,
    _ref$height = _ref.height,
    height = _ref$height === void 0 ? 0 : _ref$height;
  if (!el.style.transform) {
    return {
      width: width,
      height: height
    };
  }
  var _ref2 = ((_el$style$transform$s = el.style.transform.split('scale')[1]) === null || _el$style$transform$s === void 0 ? void 0 : (_el$style$transform$s2 = _el$style$transform$s.replace(/[()]/g, '')) === null || _el$style$transform$s2 === void 0 ? void 0 : (_el$style$transform$s3 = _el$style$transform$s2.split(',')) === null || _el$style$transform$s3 === void 0 ? void 0 : _el$style$transform$s3.map(Number)) || [1, 1],
    _ref3 = _slicedToArray(_ref2, 2),
    xScale = _ref3[0],
    yScale = _ref3[1];
  return {
    width: Number((width / (xScale || 1)).toFixed(2)),
    height: Number((height / (yScale || 1)).toFixed(2))
  };
};
export var calculateWrapperHeight = function calculateWrapperHeight(nodeSizes, itemHeight, wrapperWidth, offset, isMobile) {
  var rows = 1;
  var rowWidth = 0;
  var colGap = 4;
  var rowGap = isMobile ? 4 : 8;
  if (!wrapperWidth) {
    return 'auto';
  }
  nodeSizes.forEach(function (_ref4) {
    var width = _ref4.width;
    if (rowWidth + width > wrapperWidth - offset) {
      rowWidth = width + colGap;
      rows += 1;
    } else {
      rowWidth += width + colGap;
    }
  });
  return rows * itemHeight + (rows - 1) * rowGap;
};
export var calculateOffset = function calculateOffset(ref) {
  if (!ref.current) {
    return DEFAULT_OFFSET;
  }
  var style = window.getComputedStyle(ref.current);
  if (style.boxSizing !== '') {
    return parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
  }
  return DEFAULT_OFFSET;
};